/* Bagpacks — product page: variant selection, quantity, live price/line total. */
(function () {
  'use strict';

  var root = document.querySelector('[data-bp-product]');
  if (!root) return;

  var dataEl = root.querySelector('#bp-variant-data');
  var variants = [];
  try { variants = JSON.parse(dataEl.textContent); } catch (e) { variants = []; }

  var idInput = root.querySelector('#bp-variant-id');
  var priceEl = root.querySelector('#bp-price');
  var compareEl = root.querySelector('#bp-compare');
  var saveEl = root.querySelector('#bp-save');
  var addBtn = root.querySelector('#bp-add-btn');
  var addLabel = root.querySelector('#bp-add-label');
  var stockEl = root.querySelector('#bp-stock');
  var qtyEl = root.querySelector('#bp-qty');
  var galleryMain = root.querySelector('#bp-gallery-main');

  var selected = {};
  root.querySelectorAll('[data-bp-option-index]').forEach(function (group) {
    var idx = group.getAttribute('data-bp-option-index');
    var active = group.querySelector('.is-active');
    if (active) selected[idx] = active.getAttribute('data-bp-value');
  });

  function money(cents) { return '£' + (Math.round(cents) / 100).toFixed(2); }

  function currentVariant() {
    return variants.find(function (v) {
      return v.options.every(function (val, i) { return selected[String(i + 1)] === val; });
    });
  }

  function qty() { return Math.max(1, parseInt(qtyEl ? qtyEl.textContent : '1', 10) || 1); }

  function render() {
    var v = currentVariant() || variants[0];
    if (!v) return;
    if (idInput) idInput.value = v.id;

    if (priceEl) priceEl.textContent = money(v.price);
    if (compareEl) {
      if (v.compare_at_price && v.compare_at_price > v.price) {
        compareEl.textContent = money(v.compare_at_price);
        compareEl.hidden = false;
        if (saveEl) { saveEl.textContent = 'Save ' + money(v.compare_at_price - v.price); saveEl.hidden = false; }
      } else {
        compareEl.hidden = true;
        if (saveEl) saveEl.hidden = true;
      }
    }

    if (addBtn) {
      if (v.available) {
        addBtn.disabled = false;
        if (addLabel) addLabel.textContent = 'Add to bag · ' + money(v.price * qty());
        if (stockEl) { stockEl.hidden = false; }
      } else {
        addBtn.disabled = true;
        if (addLabel) addLabel.textContent = 'Sold out';
        if (stockEl) stockEl.hidden = true;
      }
    }

    if (galleryMain && v.featured_image && v.featured_image.src) {
      galleryMain.src = v.featured_image.src;
    }
  }

  /* option buttons */
  root.querySelectorAll('[data-bp-option-index] [data-bp-value]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var group = btn.closest('[data-bp-option-index]');
      var idx = group.getAttribute('data-bp-option-index');
      group.querySelectorAll('[data-bp-value]').forEach(function (b) { b.classList.remove('is-active'); });
      btn.classList.add('is-active');
      selected[idx] = btn.getAttribute('data-bp-value');
      var sel = group.querySelector('.bp-opt__selected');
      if (sel) sel.textContent = btn.getAttribute('data-bp-value');
      render();
    });
  });

  /* quantity */
  root.querySelectorAll('[data-bp-qty]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var dir = parseInt(btn.getAttribute('data-bp-qty'), 10);
      var next = Math.max(1, qty() + dir);
      if (qtyEl) qtyEl.textContent = next;
      var qInput = root.querySelector('#bp-qty-input');
      if (qInput) qInput.value = next;
      render();
    });
  });

  /* thumbnails */
  root.querySelectorAll('[data-bp-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      if (galleryMain) galleryMain.src = thumb.getAttribute('data-bp-thumb');
      root.querySelectorAll('[data-bp-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
    });
  });

  render();
})();
